import { createAsyncThunk } from '@reduxjs/toolkit'
import { IBasicEntityBase } from '../data/Common'
import { TMemCytoData } from '../data/CytoData'


export function createGetCytoThunk(contextString: string) {
    console.log(`createGetThunk ${contextString}`)
    return createAsyncThunk(
        contextString,
        async (identity: IBasicEntityBase) => {
            console.log("Fired cyto thunk")
            const requestUrl = `/api/getCytoData?proc=${identity.rowKey}`
            const response = await fetch(requestUrl)
            if (response.ok) {
                const json: TMemCytoData = await response.json()
                console.log('here is cyto')
                console.log(json)
                return json
            } else {
                console.log(`Error fetching cyto data ${identity.partitionKey}:${identity.rowKey}. Status: ${response.status}`)
                return null
            }
        }
    )
}

export interface ICytoState {
    comment: string
    data: TMemCytoData
//    transposed?: TTrasposedCytoContainer
//    chartData?: TimelineValuesArray  
    status: 'idle' | 'loading' | 'failed'
}

export function  createInitialCytoState(): ICytoState  {

    const retval: ICytoState = {  
        comment: "I'm cytocine data!!!!", 
        data: {...initialStepCytoProto},
        status: 'idle'
    }

    return retval
}


export const initialStepCytoProto:TMemCytoData = {
    60: {},
    75: {},
    90: {},
    105: {}
}
